import { render } from "./ReferencesList.vue?vue&type=template&id=7ae0051c"
import script from "./ReferencesList.vue?vue&type=script&lang=js"
export * from "./ReferencesList.vue?vue&type=script&lang=js"

import "./ReferencesList.vue?vue&type=style&index=0&id=7ae0051c&lang=css"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__